import axios from "axios";

const CG_TOKENS_PRICES_LIST = "https://api.coingecko.com/api/v3/simple/price";

export const getTokenPricesFromCG = async () => {
  try {
    const metadataRequests = await axios.get(CG_TOKENS_PRICES_LIST, {
      params: {
        ids: "solana,ethereum,binancecoin,sonic-3",
        vs_currencies: "usd",
        include_market_cap: true,
        include_24hr_vol: true,
        include_24hr_change: true,
        include_last_updated_at: true,
        precision: "full",
      },
      headers: {
        accept: "application/json",
        "x-cg-demo-api-key": "CG-oJKiyc4erLzXQeQsrBYwh8ta",
      },
    });

    return metadataRequests.data;
  } catch (error) {
    console.error("Error fetching token metadata:", error);
    throw error;
  }
};
